(function () {
    'use strict';

    var module = angular.module('app.directives');
    module.directive('swaggerDataType', [function () {
        var directive = {
            restrict: 'E',
            transclude: true,
            replace:true,
            template: '<span class="bootstrap-label {{ labelClass }}" ng-transclude></label>',
            link: link,
            scope: {
                typeData: '='
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var typeData = scope.typeData || '';
            switch (typeData) {
                case 'integer':
                    scope.labelClass = 'bg-color-blue txt-color-white';
                    break;
                case 'number':
                    scope.labelClass = 'bg-color-teal txt-color-white';
                    break;
                case 'string':
                    scope.labelClass = 'bg-color-greenDark txt-color-white';
                    break;
                case 'boolean':
                    scope.labelClass = 'bg-color-redLight txt-color-white';
                    break;
                default:
                    scope.labelClass = 'label-default';
                    break;
            }
        }
    }]);
})();